<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="120">
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="项目名称" prop="projId">
                        <Select v-model="info.projId" :disabled="this.id != ''" 
                            transfer clearable placeholder>
                            <Option v-for="(item, index) in projList"
                                :value="item.id"
                                :key="index">
                                {{item.projName}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="推荐报备有效期" prop="reportedDays">
                        <input-number style="width:70%; margin-right: 5px" :allowDecimal="false" v-model="info.reportedDays" />天
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="到访确认有效期" prop="visitDays">
                        <input-number style="width:70%; margin-right: 5px" :allowDecimal="false" v-model="info.visitDays" />天
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="说明" prop="remark">
                        <Input v-model="info.remark" type="textarea" :rows="3" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { projRulesAdd, projRulesUpdate, projRulesView } from '@/api/rule-manage'
import { projList } from '@/api/proj-manager'

export default {
    name: 'FormRule',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            loading: false,
            info: {
                id: this.id,
                projId: '', // 项目名称
                reportedDays: '3', // 推荐报备有效期
                visitDays: '30', // 到访确认有效期
                remark: '', // 说明
                ver: '' // 版本号
            },
            projList: []
        }
    },

    computed: {
        ruleValidate() {
            return {
                projId: [{ required: true, message: '项目名称必填' }],
                reportedDays: [
                    { required: true, message: '推荐报备有效期必填' }
                ],
                visitDays: [{ required: true, message: '到访确认有效期必填' }]
            }
        },

        canSave() {
            return this.id ? this.$can("update") : this.$can("add")
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return projRulesView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        disabled() {
            return this.id == ''
        }
    },

    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]

        this.loading = true
        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)
        console.log(this.canSave)

        // 预加载
        this.$modal.beforeEnter(next => {
            let body = {
                page: 1,
                pageSize: 999
            }
            Promise.all([this.fetch(), projList(body)])
                .then(args => {
                    var [view, proj] = args

                    if (view) {
                        var viewData = view.data
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                    if (proj) {
                        this.projList = proj.data.page.list
                    }
                })
            .finally(() => {
                next()
            })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = Object.assign({}, this.info)

                    if (this.id) {
                        return projRulesUpdate(formData)
                    } else {
                        return projRulesAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>
